import script from "./FormGradeAndStatusTopBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./FormGradeAndStatusTopBlock.vue?vue&type=script&setup=true&lang=js"

import "./FormGradeAndStatusTopBlock.vue?vue&type=style&index=0&id=4d642e16&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d642e16"]])

export default __exports__